import { Controller } from '@hotwired/stimulus'

// Tips array editor controller for health goals
// Usage: data-controller="admin--tips-editor"
export default class extends Controller {
  static targets = ['container', 'template', 'hidden']

  connect() {
    this.updateHiddenField()
  }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget.content.cloneNode(true)
    const index = Date.now() // Use timestamp as unique index

    // Replace INDEX placeholder with actual index
    template.querySelectorAll('[name*="INDEX"]').forEach((el) => {
      el.name = el.name.replace('INDEX', index)
    })
    template.querySelectorAll('[data-index]').forEach((el) => {
      el.dataset.index = index
    })

    this.containerTarget.appendChild(template)
    this.updateHiddenField()
  }

  remove(event) {
    event.preventDefault()
    const tipItem = event.currentTarget.closest('[data-tips-item]')
    if (tipItem) {
      tipItem.remove()
      this.updateHiddenField()
    }
  }

  updateField() {
    this.updateHiddenField()
  }

  updateHiddenField() {
    const tips = []
    const tipItems = this.containerTarget.querySelectorAll('[data-tips-item]')

    tipItems.forEach((item) => {
      const title = item.querySelector('[data-field="title"]')?.value || ''
      const body = item.querySelector('[data-field="body"]')?.value || ''
      const icon = item.querySelector('[data-field="icon"]')?.value || ''

      if (title || body) {
        const tip = { title, body }
        if (icon) tip.icon = icon
        tips.push(tip)
      }
    })

    this.hiddenTarget.value = JSON.stringify(tips)
  }

  // Drag and drop for reordering tips
  dragStart(event) {
    event.dataTransfer.effectAllowed = 'move'
    event.currentTarget.classList.add('opacity-50')
    this.draggedItem = event.currentTarget.closest('[data-tips-item]')
  }

  dragEnd(event) {
    event.currentTarget.classList.remove('opacity-50')
    this.containerTarget.querySelectorAll('[data-tips-item]').forEach((item) => {
      item.classList.remove('border-t-2', 'border-blue-500')
    })
    this.updateHiddenField()
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }

  dragEnter(event) {
    event.preventDefault()
    const target = event.currentTarget.closest('[data-tips-item]')
    if (target && target !== this.draggedItem) {
      target.classList.add('border-t-2', 'border-blue-500')
    }
  }

  dragLeave(event) {
    const target = event.currentTarget.closest('[data-tips-item]')
    if (target) {
      target.classList.remove('border-t-2', 'border-blue-500')
    }
  }

  drop(event) {
    event.preventDefault()
    const target = event.currentTarget.closest('[data-tips-item]')
    if (target) {
      target.classList.remove('border-t-2', 'border-blue-500')
    }

    if (this.draggedItem && target && target !== this.draggedItem) {
      const items = Array.from(this.containerTarget.querySelectorAll('[data-tips-item]'))
      const draggedIndex = items.indexOf(this.draggedItem)
      const targetIndex = items.indexOf(target)

      if (draggedIndex < targetIndex) {
        target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
      } else {
        target.parentNode.insertBefore(this.draggedItem, target)
      }
    }
  }
}
